import {env} from '@/config';
import {DocumentType} from '@/types/common';
import {RoomMetadata} from '@/types/matrix';

const {APP_VARIANT} = env;

export const isNotExcludedRoom = (metadata: RoomMetadata | null): boolean => {
  return metadata &&
    (metadata.appVariant === APP_VARIANT ||
      metadata.documentType === DocumentType.P2P)
    ? true
    : false;
};
